import { z } from 'zod';

export const apiResponseMetaSchema = z.object({
  success: z.boolean(),
  errorCode: z.number().int(),
  errorMessage: z.string().nullable(),
  elapsed: z.number().int()
});
export type ApiResponseMeta = z.infer<typeof apiResponseMetaSchema>;

export function apiResponseSchema<T extends z.ZodTypeAny>(dataSchema: T) {
  return apiResponseMetaSchema.extend({
    data: dataSchema.nullable()
  });
}

export type ApiResponse<T> = ApiResponseMeta & {
  data: T | null;
};

export const deletedEntityDataSchema = z.object({
  id: z.string()
});
export type DeletedEntityData = z.infer<typeof deletedEntityDataSchema>;

export function unwrapApiResponseData<T>(response: ApiResponse<T>): T {
  if (!response.success || response.data === null) {
    throw new Error(response.errorMessage ?? 'API request failed.');
  }

  return response.data;
}
